<template>
  <v-list-item
    :router="!!toRoute"
    :disabled="disabled"
    :to="toRoute"
    :input-value="isActive"
    color="default"
  >
    <v-list-item-icon>
      <v-icon small>{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title><slot></slot></v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
export default {
  name: "SideMenuListItem",
  props: {
    route: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    facilityId: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const route = useRoute();
    const router = useRouter();

    const toRoute = computed(() => {
      if (props.disabled) return undefined;
      return {
        name: props.route,
        params: props.facilityId
          ? { organization_id: props.facilityId }
          : undefined,
      };
    });

    // Drive the highlight ourselves rather than relying on Vuetify's Routable
    // active state, which leaves a stale `v-list-item--active` class on an item
    // (e.g. Facility Dashboard) after navigating away to an unrelated route.
    // Path-prefix match so a parent item stays highlighted on its drilldown
    // sub-routes (e.g. Renters → a specific renter).
    const isActive = computed(() => {
      const target = toRoute.value;
      if (!target) return false;
      let resolvedPath;
      try {
        resolvedPath = router.resolve(target).route.path;
      } catch {
        return false;
      }
      // A route that fails to build (e.g. a missing param) can resolve to "/",
      // which would match every path — fall back to an exact name check.
      if (!resolvedPath || resolvedPath === "/") {
        return route.name === target.name;
      }
      return (
        route.path === resolvedPath || route.path.startsWith(`${resolvedPath}/`)
      );
    });

    return { toRoute, isActive };
  },
};
</script>
